<template>
	<div
		class="c-sponsors"
		:class="{
			'is-hidden-on-event': !$arenaConfig.showFooterOnEvent,
			[modifier]: modifier,
			'-blend-logos': blendLogos,
		}"
	>
		<div class="l-container">
			<div
				v-for="(level, levelKey) in sponsors"
				:key="levelKey"
				class="c-sponsors__section"
				:class="`-level-${level.level}`"
			>
				<h2 class="c-sponsors__title">
					{{ level.title }}
				</h2>
				<div class="c-sponsors__logo-w">
					<div
						v-for="(sponsor, sponsorKey) in level.sponsors"
						:key="sponsorKey"
						class="c-sponsors__logo-item"
					>
						<component
							:is="sponsor.link ? 'a' : 'span'"
							:href="sponsor.link || null"
							:target="sponsor.link ? '_blank' : null"
							:rel="sponsor.link ? 'noopener' : null"
							class="c-sponsors__logo-link"
						>
							<img
								:src="sponsor.image"
								class="c-sponsors__logo"
								:alt="sponsor.title"
							>
						</component>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:  'FooterSponsors',
	props: {
		sponsors: {
			type:     Object,
			required: true,
		},
		modifier: {
			type:    String,
			default: '',
		},
		blendLogos: {
			type:    Boolean,
			default: false,
		},
	},
};
</script>
